<section>
  <div class="header d-none d-md-block">
    <h1 class="d-inline-flex v-align-middle astral-heading-with-help">
      <span>{{ 'B2C_SUBS.LIST_HEADER' | translate }}</span>
      <astral-popover [helpText]="'B2C_SUBS.HEADER_TOOLTIP'"></astral-popover>
    </h1>
  </div>
  <div class="header d-flex d-md-none align-items-center">
    <h1 class="w-100 astral-heading-with-help">
      <span>{{ 'B2C_SUBS.LIST_HEADER' | translate }}</span>
      <astral-popover [helpText]="'B2C_SUBS.HEADER_TOOLTIP'"></astral-popover>
    </h1>
  </div>
  <form class="filter astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
      <astral-date-picker [control]="form.controls['from']" [label]="'DIRECT_DEBIT.FROM'" [model]="from" [isRequired]="true"></astral-date-picker>
      <astral-date-picker [control]="form.controls['to']" [label]="'DIRECT_DEBIT.TO'" [model]="to" [isRequired]="true"></astral-date-picker>
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <astral-input [control]="form.controls['payerName']"></astral-input>
      <div class="astral-form-adjacent-action">
        <astral-button variant="secondary" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
      </div>
    </astral-layout-group>
  </form>
  @if (dataContext) {
    <div>
      <app-list-view
        [columnDefinition]="columnDefinitions"
        [contextMenuDefinition]="contextMenuDefinition"
        [itemsSource]="dataContext"
        [preferencesKey]="preferencesKey"
      ></app-list-view>
    </div>
  }
</section>
